import { get, post } from "../api";

export const verifyEmail = async (token: string) => {
    const response = await get(`/auth/verify-email?token=${token}`);
    return response.data;
};

export const resendVerificationEmail = async (email: string) => {
    const response = await post(`/auth/resend-verification?email=${email}`, {});
    return response.data;
};
